import BenefitPrice from './BenefitPrice'

export default BenefitPrice
